import React, { useState, useEffect, useMemo } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChatContacts from "./ChatContacts";
import ChatMessages from "./ChatMessages";
import ChatSendMessage from "./ChatSendMessages";
import { useQuery } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";
import PeopleIcon from "@mui/icons-material/People";

const Chat = () => {
  const { fetchOnlyData } = SupervisorApi();
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedContactName, setSelectedContactName] = useState(null);
  const [openMessage] = useState(true);

  const { data, refetch } = useQuery({
    queryKey: ["supervisorContacts"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("chats/contacts"),
    retry: 2,
    refetchOnMount: false, // Disable refetch on mount
    refetchOnWindowFocus: false,
  });

  const allUnread = useMemo(() => {
    if (!data || typeof data !== "object") return [];

    return Object.values(data).flatMap((company) =>
      company.users.flatMap((user) =>
        user.messages.filter(
          (msg) => Number(msg.is_read) === 0 && msg.role === "receiver"
        )
      )
    );
  }, [data]);

  useEffect(() => {
    const unreadCount = allUnread.length; // Get total unread messages count
    console.log("Total Unread Count:", unreadCount);
    // setTotalUnreadMessages(unreadCount);
  }, [allUnread]);

  const handleContactClick = (contactId, name) => {
    setSelectedContact(contactId);
    setSelectedContactName(name);
  };

  const handleRefetch = () => {
    setTimeout(() => {
      refetch();
    }, 2000);
  };

  return (
    openMessage && (
      <div className="pt-2 bg-gray-100   lg:w-full shadow-lg rounded-lg ">
        <div className=" flex h-full">
          {/* Contact List */}
          <div className="w-1/6 bg-gray-100 p-3 border-r text-gray-800 border-gray-200 overflow-y-auto ">
            <h2 className="font-bold mb-4 text-xl ">
              {" "}
              <PeopleIcon /> Contacts
            </h2>
            <ChatContacts handleContactClick={handleContactClick} data={data} />
          </div>

          {/* Chat Screen */}
          <div className="w-5/6 flex bg-white flex-col">
            <div className="p-4 border-b border-gray-200">
              <h2 className="font-bold text-gray-800">
                {selectedContactName ? (
                  <div>
                    {" "}
                    <AccountCircleIcon /> {selectedContactName}
                  </div>
                ) : (
                  "Select a contact"
                )}
              </h2>
            </div>
            <ChatMessages
              selectedContact={selectedContact}
              handleRefetch={handleRefetch}
            />
            <ChatSendMessage selectedContact={selectedContact} />
          </div>
        </div>
      </div>
    )
  );
};

export default Chat;
